import request from '@/utils/request';

function orderList(query) {
  return request({
    url: `/cp/v1/pnp/order_list`,
    method: 'get',
    params: query,
  });
}

function orderLog(query) {
  return request({
    url: `/cp/v1/pnp/order_log`,
    method: 'get',
    params: query,
  });
}

function orderVolice(query) {
  return request({
    url: `/cp/v1/pnp/order_voice`,
    method: 'get',
    params: query,
  });
}

function orderDetail(query) {
  return request({
    url: `/cp/v1/order/detail`,
    method: 'get',
    params: query,
  });
}

function telList(query) {
  return request({
    url: `/cp/v1/pnp/tel_list`,
    method: 'get',
    params: query,
  });
}

function unbindTel(data) {
  return request({
    url: `/cp/v1/pnp/unbind_tel`,
    method: 'post',
    data,
  });
}

function modifyTel(data) {
  return request({
    url: `/cp/v1/pnp/modify_tel`,
    method: 'post',
    data,
  });
}

function bindTel(data) {
  return request({
    url: `/cp/v1/pnp/bind_tel`,
    method: 'post',
    data,
  });
}

function accountlist(query) {
  return request({
    url: `/cp/v1/employee/accountlist`,
    method: 'get',
    params: query,
  });
}

function accountdel(data) {
  return request({
    url: `/cp/v1/employee/accountdel`,
    method: 'post',
    data,
  });
}


export default {
  orderList,
  orderLog,
  orderVolice,
  orderDetail,
  telList,
  unbindTel,
  modifyTel,
  bindTel,
  accountlist,
  accountdel
};
